import React from "react";
import { TrendingIndicatorTemplate } from "themes/administration/analytics/components";

function TrendingIndicator(props) {
    return <TrendingIndicatorTemplate {...props} />;
}

export default TrendingIndicator;
